export default function dateNameType(formatLength) {
    var nameType;
    if (formatLength <= 3) {
        nameType = "abbreviated";
    } else if (formatLength === 4) {
        nameType = "wide";
    } else if (formatLength === 5) {
        nameType = "narrow";
    } else if (formatLength === 6) {
        nameType = "short";
    }

    return nameType;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/dates/date-name-type.js
// module id = 470
// module chunks = 0